import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContacts } from "@store/action/smartend/ContactAction";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "@styles/sass/5-pages/contact.scss";

const Contact = () => {
  const dispatch = useDispatch();
  const ContactReducer = useSelector((state) => state.ContactReducer);
  const contact = ContactReducer.data.data;
  useEffect(() => {
    dispatch(getContacts());
  }, []);
  const { t } = useTranslation();
  const RadioReducer = useSelector((state) => state.RadioReducer);
  const latitude = RadioReducer.single?.latitude;
  const longitude = RadioReducer.single?.longitude;

  return (
    <div className="Ushno">
      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>{t("Contact us")}</h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Contact
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-part">
        <div className="container__video">
          <div className="row">
            <div className="col-lg-4">
              <div className="contact-info-ui" style={{ height: "100%" }}>
                <i className="fa fa-map-marker"></i>
                <h3>{t("Find us")}</h3>
                <p>{contact?.address}</p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact-info-ui" style={{ height: "100%" }}>
                <i className="fa fa-phone"></i>
                <h3>{t("Make a Call")}</h3>
                <p>
                  {t("Phone")}: {contact?.phone}
                  <span>
                    {t("Mobile")}: {contact?.mobile}
                  </span>
                  <span>Fax: {contact?.fax}</span>
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="contact-info-ui" style={{ height: "100%" }}>
                <i className="fa fa-envelope"></i>
                <h3>{t("Send Mail")}</h3>
                <p>
                  <span>{contact?.email}</span>
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-lg-12">
              <div className="contact-map">
                <iframe
                  src={`https://maps.google.com/maps?q=${latitude},${longitude}&output=embed`}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  style={{ border: "0" }}
                  allowFullScreen="100%"
                  aria-hidden="false"
                  tabIndex="0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
